import styled from 'styled-components'

import { ColorSelector, fromMd, timingDefault } from '@syconium/little-miss-figgy'

export const Container = styled.section`
  margin: 16px 16px 0 16px;
  ${fromMd} {
    margin-left: 0px;
  }

  transition: margin-top ${timingDefault} linear;
`

export const StyledColorSelector = styled(ColorSelector)`` as typeof ColorSelector
